import React from 'react';
import { useTranslation } from 'react-i18next';
import {Nav} from 'react-bootstrap';

function SubscriptionTab(){
  const { t } = useTranslation(['settings']);
  return(
    <Nav.Item>
      <Nav.Link eventKey="subscription" style={{fontSize:14}} className="text-center text-md-start">
        <i style={{width:20}} className="fas fa-money-check-alt text-center me-2"></i>{t('subscription.panelName')}
      </Nav.Link>
    </Nav.Item>
  );
}

export default SubscriptionTab;
